import api from '@/lib/axios';
import {
    PricingRequest,
    PricingResponse,
    CartPricingRequest,
    CartPricingResponse,
    PriceValidationRequest,
    PriceValidationResponse
} from '@/types';

/**
 * Calculate price for a single item using tiered pricing
 */
export const calculateItemPrice = async (request: PricingRequest): Promise<PricingResponse> => {
    const response = await api.post<PricingResponse>('/customer/pricing/calculate-item', request);
    return response.data;
};

/**
 * Calculate cart total using tiered pricing
 */
export const calculateCartPrice = async (request: CartPricingRequest): Promise<CartPricingResponse> => {
    const response = await api.post<CartPricingResponse>('/customer/pricing/calculate-cart', request);
    return response.data;
};

/**
 * Validate cart prices against current pricing before checkout.
 * Used to detect price changes since cart was last calculated.
 */
export const validateCartPricing = async (request: PriceValidationRequest): Promise<PriceValidationResponse> => {
    const response = await api.post<PriceValidationResponse>('/customer/pricing/validate-cart', request);
    return response.data;
};
